const map = {
	"./Honey.png": 166,
	"./LMS.png": 99,
	"./MsFat.png": 74,
	"./NN.png": 919,
	"./OMG.png": 700,
	"./automate.jpeg": 434,
	"./civilazation.png": 524,
	"./eagle.jpeg": 640,
	"./fbastart.jpeg": 21,
	"./grove.png": 246,
	"./leadsnotify.jpeg": 226,
	"./locate.png": 965,
	"./logo1.png": 621,
	"./logo2.png": 942,
	"./logo3.png": 31,
	"./logo5.png": 201,
	"./logo6.png": 58,
	"./logo7.png": 411,
	"./logo8.png": 172,
	"./logo9.png": 61,
	"./payactiv.jpeg": 385,
	"./peng.jpeg": 256,
	"./princevisa.png": 647,
	"./salt.png": 91,
	"./yusif.png": 792
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 424;